import React from "react";
import { Link } from "react-router-dom";
import Button from "../../../components/Button/Button";
import banner from "../../../images/main-banner.jpg";
import "./Banner.css";
const Banner = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${banner})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "50vh",
      }}
      className="relative"
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          right: "0",
          transform: "translateY(-50%)",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          padding: "30px 25px",
        }}
        className="max-w-6xl mx-auto w-1/2 hidden lg:block"
      >
        <div>
          <span className="uppercase font-semibold text-white p-2">
            {" "}
            We are here for you
          </span>

          <h2 className=" sm:text-4xl text-7xl my-5 text-white font-bold  capitalize relative banner-title">
            Find your dream car <br />
            with CarDealer
          </h2>
          <h6 className="text-white font-normal text-xl w-3/4 mt-5">
            We provide the best solution for your car needs.We offer great
            vehicle round the clock.
          </h6>
         <Link to="/collection">
         <Button>Top Car</Button>
         </Link>
        </div>
      </div>
    
     <div className="flex justify-center items-center h-full mobile-banner lg:hidden ">
        <div>
        <h2 className="text-3xl text-white font-bold capitalize p-4 mobile-banner-title relative">Find your dream car <br /> with CarDealer</h2>
        <Button>Top Car</Button>
        </div>
     </div>
    </div>
  );
};

export default Banner;
